//@ts-ignore
import { CLESSON_MODES } from '@yandex-int/k-common/constants';
import { LESSON_STATUS } from '@yandex-int/k-common/typings';
import { Text } from 'platform-components';
import React, { useCallback } from 'react';

import { AssignmentSendLinkControl } from 'common.components/lesson-view.assignment/__send-link-control/assignment__send-link-control';
import { isLessonInProgress } from 'common.components/lesson/utils';
import { StudentsList } from 'common.components/students-list/students-list';
import { STUDENTS_ERRORS } from 'common.components/students-list/typings';

import { AssignmentAddStudentsControl } from '../__add-students-control/assignment__add-students-control';

interface Props {
    canAssignIndividually: boolean;
    lessonMode: CLESSON_MODES;
    selectedStudents: Array<number>;
    studentsError: STUDENTS_ERRORS | null;
    isAllTeamCheckboxDisabled: boolean;
    inStudentLinkExperiment: boolean;
    onToggleStudentAssignment: (selected: Array<number>) => void;
    canEditTeam: boolean;
    onAddStudentsClick: () => void;
    onSendStudentLinkClick: () => void;
    lessonStatus: LESSON_STATUS;
    assignmentTable: Array<string>;
    isTeamFromMes: boolean;
}

export const AssignmentStudentsMode = (props: Props) => {
    const {
        canAssignIndividually,
        lessonMode,
        selectedStudents,
        studentsError,
        isAllTeamCheckboxDisabled,
        inStudentLinkExperiment,
        onToggleStudentAssignment,
        canEditTeam,
        onAddStudentsClick,
        onSendStudentLinkClick,
        lessonStatus,
        assignmentTable,
        isTeamFromMes,
    } = props;

    const getIsStudentDisabled = useCallback(
        (studentId: number) => {
            if (!canAssignIndividually) {
                return true;
            }

            const status = lessonStatus || LESSON_STATUS.NOT_ASSIGNED;

            // assignmentTable содержит черный список учеников (которым НЕ выдан урок)
            // поэтому для решаемого урока мы дизейблим тех, кого нет в этом списке (чтобы им нельзя было снять галочку)
            return isTeamFromMes || (isLessonInProgress(status) && !assignmentTable.includes(studentId.toString()));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [lessonStatus, isTeamFromMes, assignmentTable]
    );

    if (!lessonMode) {
        return (
            <div className="assignment__empty-stub">
                <Text id="assignLessonModal.selectLessonMode" />
            </div>
        );
    }

    return (
        <StudentsList
            allStudentsDisabled={isAllTeamCheckboxDisabled}
            controls={
                inStudentLinkExperiment ? (
                    <AssignmentSendLinkControl
                        canEditTeam={canEditTeam}
                        onSendStudentLinkClick={onSendStudentLinkClick}
                    />
                ) : (
                    <AssignmentAddStudentsControl canEditTeam={canEditTeam} onAddStudentsClick={onAddStudentsClick} />
                )
            }
            error={studentsError}
            getIsStudentDisabled={getIsStudentDisabled}
            onToggleAllStudents={onToggleStudentAssignment}
            onToggleStudent={onToggleStudentAssignment}
            selected={selectedStudents}
            shouldHideCheckbox={!canAssignIndividually}
        />
    );
};
